import gql from 'graphql-tag'

export const cartHashQuery = gql`
query cartHash($cartId: ID) {
    cart(id: $cartId) {
        hash
    }
}
`
